export default __webpack_public_path__ + "static/media/ninos-Banner-Curso-PPT-Children-270x180.58c66827.jpg";